const HeaderPortfolioDetail = ({text}) => {
    return(
        <div className={'w-full p-5 bg-slate-900 dark:bg-slate-950 transition-colors duration-300'}>
            <h1 className={'text-white font-semibold text-2xl text-center'}>
                {text}
            </h1>
        </div>
    )
}
export default HeaderPortfolioDetail;